import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const salesOrderVoidAtom = createMutationAtomFactory(
  'trade.salesOrderVoid',
  (params: { id: string; forceUnlink?: boolean }) => ({
    tradeSalesOrderVoid: {
      __args: {
        id: params.id,
        forceUnlink: params.forceUnlink,
      },
      salesOrder: {
        id: true,
        documentNumber: true,
        status: true,
      },
      blockingLoads: {
        id: true,
        documentNumber: true,
      },
      unlinkableLoads: {
        id: true,
        documentNumber: true,
      },
      requiresConfirmation: true,
    },
  }),
);
